export default {
    ALREADY_EXISTS: 'Meron nang guild na may ganitong pangalan',
    ALREADY_IN_GUILD: 'Ikaw ay nasa guild na.',
    CANNOT_KICK_YOURSELF: 'Hindi mong pwedeng paalisin ang iyong sarili',
    GUILD_FULL: 'Puno na ang Guild mo.',
    MUST_FINISH_TUTORIAL_CREATE: 'Dapat mong tapusin ang tutorial, bago ka makagawa ng guild',
    NO_PERMISSION: 'Kailangan mo ng permisyon para gawin yan.',
    NO_PERMISSION_RANK: 'Wala kang permisyon na i-update ang ranggo ng miyembrong iyon.',
    NOT_ENOUGH_GOLD:
        'Kailangan mo ng 30,000 gold sa iyong imbentaryo para maka gawa ng isang guild.',
    NOT_ALLOWED_GUESTS_JOIN: 'Ang mga Guest ay hindi pwedeng sumali sa mga guild.',
    NOT_ALLOWED_GUESTS_CREATE: 'Ang mga guest ay hindi pwedeng gumawa nang guild.'
} as const;
